import React from "react";

export interface ISwitchProps
    extends React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
    > {
    swicthSize?: "lg" | "sm";
    color:
        | "success"
        | "primary"
        | "warning"
        | "info"
        | "danger"
        | "primary"
        | "dark"
        | "brand";
    noIcon?: boolean;

    type?: "checkbox";

    label?: string;
    labelPosition?: "top" | "bottom";
    labelClassName?: string;
    wrapperClassName?: string;

    removeDefaultStyle?: boolean;
}

export const Switch = React.forwardRef<HTMLInputElement, ISwitchProps>(
    (props, ref) => {
        const {
            swicthSize,
            color,
            noIcon,
            label,
            labelPosition,
            className,
            labelClassName,
            wrapperClassName,
            removeDefaultStyle,
            ...inputProps
        } = props;

        return (
            <div
                className={`${wrapperClassName} ${
                    !removeDefaultStyle
                        ? "d-flex flex-column align-itens-center justify-content-end"
                        : ""
                }`}
            >
                {labelPosition === "top" && (
                    <div
                        className={`${labelClassName} ${
                            !removeDefaultStyle
                                ? "text-center font-weight-bold"
                                : ""
                        }`}
                    >
                        {label}
                    </div>
                )}
                <span
                    className={`switch switch-outline ${
                        swicthSize ? `switch-${swicthSize}` : ""
                    } ${!noIcon ? "switch-icon" : ""} switch-${color} ${
                        !removeDefaultStyle
                            ? "d-flex justify-content-center"
                            : ""
                    } ${className}`}
                    data-toggle="tooltip"
                >
                    <label>
                        <input {...inputProps} ref={ref} />
                        <span></span>
                    </label>
                </span>
                {labelPosition !== "top" && (
                    <div
                        className={`${labelClassName} ${
                            !removeDefaultStyle
                                ? "text-center font-weight-bold"
                                : ""
                        }`}
                    >
                        {label}
                    </div>
                )}
            </div>
        );
    }
);
